/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encode a website URL so people can open it by scanning.`)
};

const es_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica la URL de un sitio web para que la gente pueda abrirlo escaneando.`)
};

const de_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codiere eine Website-URL, damit Menschen sie durch Scannen öffnen können.`)
};

const nl_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codeer een website-URL zodat mensen hem kunnen openen door te scannen.`)
};

const fr_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodez l'URL d'un site web pour que les gens puissent l'ouvrir en scannant.`)
};

const it_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica l'URL di un sito web così le persone possono aprirlo scansionando.`)
};

const pt_br2_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifique a URL de um site para as pessoas abrirem escaneando.`)
};

const pt_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifique o URL de um website para que as pessoas o possam abrir ao ler o código.`)
};

const ja_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウェブサイトのURLを埋め込めば、スキャンするだけで開けます。`)
};

const zh_qr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将网站链接编码进二维码，方便他人扫描打开。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_ex1", locale)
	if (locale === "en") return en_qr_ex1(inputs)
	if (locale === "es") return es_qr_ex1(inputs)
	if (locale === "de") return de_qr_ex1(inputs)
	if (locale === "nl") return nl_qr_ex1(inputs)
	if (locale === "fr") return fr_qr_ex1(inputs)
	if (locale === "it") return it_qr_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_qr_ex1(inputs)
	if (locale === "pt") return pt_qr_ex1(inputs)
	if (locale === "ja") return ja_qr_ex1(inputs)
	return zh_qr_ex1(inputs)
};